import React, { useRef, useState, useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";
import { Spin } from "antd";
import { POST_GetTopCustomersData } from "../../../helpers/url_helper";

import * as echarts from "echarts";

const TopCustomer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DayType: 1,
      TopCustomerList: [],
      CustomerNames: [],
      TestingCounts: [],
      PeriodType: 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      DayType,
      TopCustomerList,
      CustomerNames,
      TestingCounts,
      PeriodType,
    },
  } = formik;

  useEffect(() => {
    getTopCustomerDetails(1);
  }, []);

  const getTopCustomerDetails = async (typeid) => {
    formik.setFieldValue("PeriodType", typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetTopCustomersData, payload)
      .then((response) => {
        bindChartData(response?.List);
        formik.setFieldValue("TopCustomerList", response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let customerNameArray = [],
      testingCountArray = [];

    Promise.all(
      list?.map((x) => {
        customerNameArray.push(x.CustomerName);
        testingCountArray.push(x.TestingCount);
      })
    );

    formik.setFieldValue("CustomerNames", customerNameArray);
    formik.setFieldValue("TestingCounts", testingCountArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    const myChart = echarts.init(chartRef.current);

    const options = {
      title: {
        text: "",
        left: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: "{b} <br/>Testing Count : {c}",
      },
      // legend: {
      //   orient: "vertical",
      //   left: "left",
      // },
      series: [
        {
          name: "Testing Count",
          type: "pie",
          radius: "50%",
          data: TopCustomerList.map((item) => ({
            name: item.CustomerName + " - " + item.TestingCount,
            value: item.TestingCount,
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          label: {
            color: "inherit",
          },
        },
      ],
      grid: {
        left: 35,
        top: 35,
        right: "5%",
        bottom: "5%",
      },
    };

    myChart.setOption(options);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [TopCustomerList]);

  return (
    <>
      <div className="card mb-2" style={{ height: "calc(100% - 10px)" }}>
        <div className="card-body p-0">
          <Spin size="large" spinning={isLoading} tip={"Loading..."}>
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0 ps-2">Top Customer</h4>
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center">
                      <Link
                        title="Current Year"
                        className={`btn ${
                          PeriodType == 1
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopCustomerDetails(1);
                        }}
                      >
                        CY
                      </Link>
                      &nbsp;
                      <Link
                        title="Current Month"
                        className={`btn ${
                          PeriodType == 2
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopCustomerDetails(2);
                        }}
                      >
                        CM
                      </Link>
                      &nbsp;
                      <Link
                        title="Previous Month"
                        className={`btn ${
                          PeriodType == 3
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopCustomerDetails(3);
                        }}
                      >
                        PM
                      </Link>
                    </div>
                  </form>
                </FormikProvider>
              </div>
              <div
                ref={chartRef}
                style={{ width: "100%", height: "360px" }}
              ></div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default TopCustomer;
